<template>
	<div class="d-flex align-items-center gap-sm">
		<lottie-player src="/assets/animations/success.json"
			autoplay
			style="width: 25px; height: 25px; background: transparent;">
		</lottie-player>
		<slot></slot>
	</div>
</template>
